import * as helpers from '../helpers';
import SlideToggler from './slideToggler';

export default class TabsCordion {
    constructor(selector = '.tabs', options = null, prefix = 'tabs', insideDropdown = false) {
        this.selector = selector;
        this.prefix = prefix;
        this.id = null;
        this.insideDropdown = insideDropdown;
        this.options = {
            class: {
                initialized: '-is-initialized',
                trigger: `${this.prefix}__trigger`, // Clicked title in accordion or in tabs
                panel: `${this.prefix}__panel`,
                list: `${this.prefix}__list`, // List of tab state title
                listItem: `${this.prefix}__list-item`, // Title item for tabks

                typeAccordion: '-type-accordion',
                typeTab: '-type-tabs',

                stateActive: '-current',
                // stateDisabled: '-disabled', todo
                stateHidden: 'ghost',
            },
            onlyState: null,
            titleSelector: 'h2',
            initIndex: 0,
            eq: 0, // which tab open on init
            breakpoint: 768, // px
            slideDuration: 300, // ms
            beforeInit: () => {
            },
            afterInit: () => {
            },
            onInit: () => {
            },
            preCreateTrigger: (text) => {
                const checkText = text.children;

                let trigger = null;

                // If already has a button
                if (checkText.length && checkText[0] instanceof HTMLElement && checkText[0].nodeName === 'BUTTON') {
                    trigger = checkText[0];
                    // text.innerText = checkText[0].innerText;
                } else {
                    trigger = document.createElement('button');
                    trigger.innerHTML = text.innerHTML;
                }
                return trigger;
            },
        };

        if (options instanceof Object) {
            this.options = helpers.extendDefaults(this.options, options);
        }

        this.checkBeforeInit();
    }

    checkBeforeInit() {
        if (typeof this.selector === 'string') {
            const els = document.querySelectorAll(this.selector);
            for (let i = 0; i < els.length; i++) {
                const el = new TabsCordion(els[i], this.options);
            }
        } else {
            if (this.selector) {
                const parentDropdown = helpers.findAncestor(this.selector, 'click-roll');
                if (!parentDropdown || this.insideDropdown) {
                    this.init();
                }
            }
        }
    }

    init() {
        if (typeof this.selector !== 'string') {
            this.options.beforeInit(this.selector);
            this.options.onInit(this.selector);
            this.id = helpers.getUniqId();
            this.selector.setAttribute('data-tab-id', this.id);
            this.create(this.isTabs());
            helpers.addClass(this.selector, this.options.class.initialized);
            // setTimeout(this.destroy.bind(this), 1000);
            this.initEvents();

            this.options.afterInit(this.selector);
        }
    }

    getState() {
        if (!this.options.onlyState) {
            return window.innerWidth < this.options.breakpoint ? 'accordion' : 'tabs';
        }
        return this.options.onlyState;
    }

    isTabs() {
        return this.getState() === 'tabs';
    }

    create(isTabs, eqs = this.options.eq) {
        helpers.addClass(this.selector, this.options.class[isTabs ? 'typeTab' : 'typeAccordion']);

        let tabsList;
        let titles = [...this.selector.querySelectorAll(this.options.titleSelector)];
        titles = titles.filter((title) => {
            if (title.parentElement.parentElement.getAttribute('data-tab-id') !== null) {
                return title.parentElement.parentElement.getAttribute('data-tab-id') === this.id;
            }
            return title.parentElement.parentElement.parentElement.getAttribute('data-tab-id') === this.id;
        });

        if (isTabs) {
            tabsList = `<ul class="${this.options.class.list}" role="tablist">`;
        } else {
            helpers.setAttributes(this.selector, {
                role: 'tablist',
            });
        }

        titles.forEach((title, i) => {
            const panel = title.parentNode;
            const id = panel.dataset.id || helpers.getUniqId();
            const isActive = id === eqs || i === parseInt(eqs, 10);
            const trigger = this.createTrigger(id, title, isTabs);

            // Visually hide the Title
            helpers.addClass(title, this.options.class.stateHidden);

            helpers.setAttributes(panel, {
                'data-id': id, // do not remove this attr
                id: `control-${id}`,
                'aria-labelledby': `labled-${id}`,
                role: 'tabpanel',
                'aria-hidden': true, // will change on switch tabs
            });

            // Init toggler before call activatePanel method
            if (!isTabs && !panel.slideToggler) {
                panel.slideToggler = new SlideToggler(panel);
            }

            if (isActive) {
                this.activateTrigger(trigger, isTabs);
                this.activatePanel(panel, isTabs);
                helpers.setAttributes(this.selector, {
                    'data-current': id,
                });
            }

            if (isTabs) {
                tabsList += `<li class="${this.options.class.listItem}" role="presentation">${trigger.outerHTML}</li>`;
            } else {
                panel.parentNode.insertBefore(trigger, panel);
            }

            const soc = document.querySelector('.social-wall');
            if (soc) {
                if (helpers.hasClass(title, this.options.class.stateHidden)) {
                    const button = title.getElementsByTagName('BUTTON');
                    if (button) {
                        if (helpers.findAncestor(button[0], 'social-wall')) {
                            button[0].style.display = 'none';
                        }
                    }
                }
            }
        });

        if (isTabs) {
            tabsList += '</ul>';
            // Prepend tabs list before the tab panels
            if (this.selector.children.length) {
                // Covert tabsList to HTML code.
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = tabsList;
                const tabsListHTML = tempDiv.querySelector(`.${this.options.class.list}`);

                // Insert tabsList into tabs.
                this.selector.insertBefore(tabsListHTML, this.selector.children[0]);
            }
        }
    }

    createTrigger(id, text, isTabs) {
        const trigger = this.options.preCreateTrigger(text);

        // Add attributes for the Trigger
        helpers.setAttributes(trigger, {
            id: `labled-${id}`,
            'aria-controls': `control-${id}`,
            type: 'button',
            role: 'tab',
            'aria-selected': false, // will change on switch tabs
            // 'class': this.options.class.trigger,
        });

        helpers.addClass(trigger, this.options.class.trigger);

        if (!isTabs) {
            helpers.setAttributes(trigger, {
                'aria-expanded': false, // only for accordion
            });
        }

        return trigger;
    }

    activatePanel(panel, isTabs) {
        if (!isTabs && panel.slideToggler) {
            panel.slideToggler.open();
        }

        helpers.addClass(panel, this.options.class.stateActive);
        helpers.removeAttributes(panel, ['aria-hidden']);
    }

    deactivatePanel(panel, isTabs) {
        if (!isTabs && panel.slideToggler) {
            panel.slideToggler.close();
        }
        helpers.removeClass(panel, this.options.class.stateActive);
        helpers.setAttributes(panel, {
            'aria-hidden': true, // will change on switch tabs
        });
    }

    activateTrigger(trigger, isTabs) {
        trigger.focus();
        helpers.addClass(trigger, this.options.class.stateActive);
        helpers.setAttributes(trigger, {
            'aria-selected': true, // will change on switch tabs
        });
        if (!isTabs) {
            helpers.setAttributes(trigger, {
                'aria-expanded': true, // only for accordion
            });
        }
    }

    deactivateTrigger(trigger, isTabs) {
        helpers.removeClass(trigger, this.options.class.stateActive);
        helpers.setAttributes(trigger, {
            'aria-selected': false, // will change on switch tabs
        });
        if (!isTabs) {
            helpers.setAttributes(trigger, {
                'aria-expanded': false, // only for accordion
            });
        }
    }

    switchTab(trigger) {
        const isTabs = this.isTabs();
        const currentId = this.selector.dataset.current;

        // Update current id
        this.selector.dataset.current = trigger.id.replace('labled-', '');

        // Deactivate current trigger and panel
        this.deactivateTrigger(document.getElementById(`labled-${currentId}`), isTabs);
        this.deactivatePanel(document.getElementById(`control-${currentId}`), isTabs);

        // activate new ones
        this.activateTrigger(trigger, isTabs);
        this.activatePanel(document.getElementById(trigger.getAttribute('aria-controls')), isTabs);
    }

    destroy() {
        const selector = typeof this.selector === 'string' ? document.querySelector(this.selector) : this.selector;

        // Remove role attribute from main container if exists
        helpers.removeClass(selector, this.options.class.typeAccordion);
        helpers.removeClass(selector, this.options.class.typeTab);

        // Remove tabs list if it exists
        const list = selector.querySelector(`.${this.options.class.list}`);

        if (list) {
            selector.removeChild(list); // remove tabs list
        }

        let children = Array.prototype.slice.call(selector.childNodes); // Get all children of main container
        children = children.filter(child => child.nodeName !== '#text'); // filter text nodes from children set

        const removeUnnecessaryAttr = (child) => {
            if (child.nodeName === 'BUTTON') {
                child.removeEventListener('click', TabsCordion.onTogglerClick.bind(this));
                child.parentNode.removeChild(child); // remove this child if it's a button
            } else {
                helpers.removeAttributes(child, ['id', 'aria-labelledby', 'role', 'aria-hidden', 'style']); // remove all generated attributes from content item
                helpers.removeClass(child, this.options.class.stateActive);
                const title = child.querySelector(this.options.titleSelector);
                if (title) {
                    helpers.removeClass(title, this.options.class.stateHidden);
                }
            }
        };

        children.forEach((child) => {
            if (!child.getAttribute('role')) {
                const childChildren = [...child.childNodes].filter(c => c.nodeName !== '#text');

                childChildren.forEach((childChldrn) => {
                    removeUnnecessaryAttr(childChldrn);
                });
            } else {
                removeUnnecessaryAttr(child);
            }
        });
    }

    initEvents() {
        this.initEventsTriggers();

        // let panels = Array.prototype.slice.call(this.selector.querySelectorAll(`.${this.options.class.panel}`)); // Get all panels of main container
        // panels = panels.filter(panel => panel.slideToggler);

        window.addEventListener('responsive', () => {
            const isTabs = this.isTabs();
            const currentStateTabs = helpers.hasClass(this.selector, this.options.class.typeTab);
            if (isTabs !== currentStateTabs) {
                // console.log( `change state from ${currentStateTabs ? 'tabs' : 'accordion'} to ${isTabs ? 'tabs' : 'accordion'}` );
                this.destroy();
                this.create(isTabs, this.selector.dataset.current);
                this.initEventsTriggers();
            }

            // Causes a bug. Recalculates panels height after resize
            // if (!isTabs) {
            //     panels.forEach((panel) => {
            //         if(panel.slideToggler){
            //             panel.slideToggler.updateValues();
            //             //panel.slideToggler.updateValues.bind(panel.slideToggler)();
            //         }
            //     });
            // }
        });
    }

    initEventsTriggers() {
        const triggers = Array.prototype.slice.call(this.selector.querySelectorAll(`.${this.options.class.trigger}`)); // Get all triggers of main container
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', TabsCordion.onTogglerClick.bind(this));
            trigger.addEventListener('keydown', e => TabsCordion.onTogglerKeyDown.call(this, e, triggers));
        });
    }

    static onTogglerClick(e) {
        const clickedTrigger = e.target;
        const clickedId = clickedTrigger.id.replace('labled-', '');
        const currentId = this.selector.dataset.current;

        if (clickedId !== currentId) {
            this.switchTab(clickedTrigger);
        }
    }

    static onTogglerKeyDown(e, triggers) {
        const currentTrigger = document.getElementById(`labled-${this.selector.dataset.current}`);
        const currentIndex = triggers.indexOf(currentTrigger);
        const firstTrigger = triggers[0];
        const lastTrigger = triggers[triggers.length - 1];

        if (e.keyCode === 36) { // strike home on a tab => 1st tab
            if (currentTrigger !== firstTrigger) {
                this.switchTab(firstTrigger);
            }

            e.preventDefault();
        } else if (e.keyCode === 35) { // strike end on a tab => last tab
            if (currentTrigger !== lastTrigger) {
                this.switchTab(lastTrigger);
            }

            e.preventDefault();
        } else if (e.keyCode === 37 && !e.ctrlKey) { // strike left on the tab => previous tab
            if (currentTrigger === firstTrigger) {
                this.switchTab(lastTrigger);
            } else {
                this.switchTab(triggers[currentIndex - 1]);
            }

            e.preventDefault();
        } else if (e.keyCode === 39 && !e.ctrlKey) { // strike right in the tab => next tab
            if (currentTrigger === lastTrigger) {
                this.switchTab(firstTrigger);
            } else {
                this.switchTab(triggers[currentIndex + 1]);
            }

            e.preventDefault();
        }
    }
}
